import { Button } from '@mui/material';
import { styled } from "@mui/system";
// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px
// xl, extra-large: 1536px

// 共通ボタン
export const BaseButton = styled(Button)(({ theme }) => ({
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
}))

export const RequestButton = styled(BaseButton)(({ theme }) => ({
    backgroundColor: '#0A7CB7',
    '&:hover': {
        backgroundColor: '#5C98B7'
    },
    '&.Mui-disabled': {
        backgroundColor: '#B0BEC5',
        color: '#ECEFF1',
    },
    [theme.breakpoints.up("xs")]: {
        width: '100%',
    },
    [theme.breakpoints.up("sm")]: {
        width: '50%',
    },
    [theme.breakpoints.up("md")]: {
        width: '50%',
    },
    padding: '10px 0'
}))

export const RequestButtonFullWidth = styled(BaseButton)(() => ({
    backgroundColor: '#0A7CB7',
    '&:hover': {
        backgroundColor: '#5C98B7'
    },
    width: '100%',
    padding: '10px 0'
}))

export const ApprovalButton = styled(BaseButton)(() => ({
    backgroundColor: '#0A7CB7',
    '&:hover': {
        backgroundColor: '#5C98B7'
    },
    width: '30%',
    padding: '20px 0',
    minWidth: '150px'
}))

export const RejectAprovalButton = styled(BaseButton)(() => ({
    border: '2px solid #2c3e50',
    color: '#2c3e50',
    backgroundColor: '#ffffff',
    '&:hover': {
        backgroundColor: '#cad9e8'
    },
    width: '30%',
    padding: '20px 0',
    minWidth: '150px'
}))

export const ReportDownloadButton = styled(BaseButton)(() => ({
    width: '17%',
    marginRight: '80px',
    border: '2px solid #2c3e50',
    color: '#2c3e50',
    backgroundColor: '#ffffff',
    '&:hover': {
        backgroundColor: '#cad9e8'
    }
}))

export const ReportStopButton = styled(BaseButton)(({ theme }) => ({
    // width: '8%',
    padding: '8px 16px',
    border: '1px solid #dcdcdc',
    backgroundColor: '#ffffff',
    color: '#dc1e32',
    '&:hover': {
        backgroundColor: '#fdeded'
    },
    fontWeight: 'bold'
}))

export const MailConfirmButton = styled(BaseButton)(() => ({
    backgroundColor: '#0A7CB7',
    '&:hover': {
        backgroundColor: '#5C98B7'
    },
    width: '100%'
}))

export const AvailableButton = styled(BaseButton)(({ theme }) => ({
    width: '100%',
    backgroundColor: 'rgba(124, 183, 10, 1.0)',
    padding: theme.spacing(3),
    marginTop: 2,
    '&:hover': {
        backgroundColor:
            'rgba(124, 183, 10, 0.6)',
    },
    '&.Mui-disabled': {
        color: '#fff',
        opacity: 0.4,
    },
    '&.Mui-disabled[data-selected="true"]': {
        backgroundColor:
            'rgba(124, 183, 10, 0.6)',
        opacity: 1.0,
    },
}))

export const UnAvailableButton = styled(BaseButton)(({ theme }) => ({
    width: '100%',
    color: '#fff',
    fontWeight: 'bold',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: theme.spacing(3),
    marginTop: 2,
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    '&.Mui-disabled': {
        color: '#fff',
        opacity: 0.4,
    },
    '&.Mui-disabled[data-selected="true"]': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        opacity: 1.0,
    },
}))

export const RegisterButton = styled(BaseButton)(({ theme }) => ({
    width: '100%',
    backgroundColor: 'rgba(124, 183, 10, 1.0)',
    marginTop: 2,
    '&:hover': {
        backgroundColor:
            'rgba(124, 183, 10, 0.6)',
    },
    '&.Mui-disabled': {
        backgroundColor: '#B0BEC5',
        color: '#ECEFF1',
    },
    [theme.breakpoints.up("xs")]: {
        width: '100%',
    },
    [theme.breakpoints.up("sm")]: {
        width: '100%',
    },
    [theme.breakpoints.up("md")]: {
        width: '100%',
    },
    padding: '10px 0'
}))

export const RequestDetailButton = styled(Button)(({ theme }) => ({
    width: "100%",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "clamp(10px, 1.2vw, 12px)",
    backgroundColor: "rgba(124, 183, 10, 1.0)",
    "&:hover": {
        backgroundColor: "rgba(124, 183, 10, 0.8)",
    },
    "&:disabled": {
        backgroundColor: "#e0e0e0",
        color: "#888888",
        cursor: "not-allowed"
    },
    padding: "10px 0"
}));